import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a passionate <b className="purple">Full Stack Developer</b> with a deep interest in building robust and scalable digital solutions. 🚀
              <br />
              <br />
              My expertise lies in crafting high-performance web applications using modern technologies like
              <i><b className="purple"> React.js</b></i> for dynamic frontends and
              <i><b className="purple"> Laravel 12</b></i> for secure, decoupled backend architectures.
              <br />
              <br />
              Beyond just writing code, I focus on <b className="purple">System Design</b> and
              <b className="purple"> Software Architecture</b> to ensure every product I build is not only functional but also maintainable and ready for growth.
              <br />
              <br />
              I have a specialized focus on developing
              <i><b className="purple"> SaaS (Software as a Service)</b></i> platforms, aiming to drive digital transformation in the
              <b className="purple"> Middle Eastern market</b> and empower the regional freelance ecosystem.
              <br />
              <br />
              My philosophy is simple: <i className="purple">"Clean code is not a choice, it’s a standard."</i> I strive to bridge the gap between complex technical problems and seamless user experiences.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
